import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RowItems } from '../../models/TableProps';
import { LiveOrdersData } from '../../models/LiveOrders';
import { Button } from '@mui/material';
import useLiveOrderDetailsDialog from '../../hooks/dialogs/useLiveOrderDetailsDialog';
import { formatPrice } from 'utils/numberFormatter';

export const LiveOrdersTableRow: React.FC<RowItems<LiveOrdersData>> = (
    props
) => {
    const { row, index } = props;
    const { t } = useTranslation('liveOrders', { keyPrefix: 'LIVE_ORDERS' });
    const labelId = `enhanced-table-checkbox-${index}`;
    const liveOrderDetailsDialog = useLiveOrderDetailsDialog();

    const showDetails = () => {
        liveOrderDetailsDialog.showDialog(true, row);
    };

    return (
        <TableRow hover>
            <TableCell component="th" id={labelId} scope="row">
                {row.orderNo}
            </TableCell>
            <TableCell align="right">{row.orderDate}</TableCell>
            <TableCell align="right">{formatPrice(row.netAmount)} Ft</TableCell>
            <TableCell align="right">
                {formatPrice(row.amountInclVAT)} Ft
            </TableCell>
            <TableCell align="right">
                {t(
                    'TABLE_CONTENT.STATUS.' +
                        row.status.toString().toUpperCase()
                )}
            </TableCell>
            <TableCell align="right">
                <Button onClick={showDetails}>{t('TABLE_CONTENT.MORE')}</Button>
            </TableCell>
        </TableRow>
    );
};
